import logo from "./logo.svg";
import "./App.css";

import Router from "./routes/index";
import { ConfigProvider } from "antd";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useContext, useEffect } from "react";
import { UserAPI } from "./api";
import { AppContext, AppProvider } from "./context/index";
import VipModal from "./components/vipModal";

import TimeAgo from "javascript-time-ago";

import en from "javascript-time-ago/locale/en";
import ru from "javascript-time-ago/locale/ru";
import Swal from "sweetalert2";

TimeAgo.addDefaultLocale(en);
TimeAgo.addLocale(ru);

function App() {
  useEffect(() => {
    let user;
    try {
      user = JSON.parse(localStorage.getItem("user"));
    } catch {
      user = null;
    }

    if (user) {
      getUser(user?._id);
    }
  }, []);

  const getUser = async (id) => {
    try {
      const res = await UserAPI.getUser(id);
      if (res?.status == 200) {
        localStorage.setItem("user", JSON.stringify(res.data));
      }
    } catch (e) {
      // Axios interceptor will toast; don't crash app on 4xx/5xx.
    }
  };

  const { isVipModal, setVipModal } = useContext(AppContext);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#2CA3DD",
          borderRadius: 0,
          fontFamily: "'Lato', sans-serif",
        },
      }}
    >
      <Router />
      <VipModal open={isVipModal} setOpen={setVipModal} />
      <ToastContainer
        position="top-right"
        autoClose={7000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        // transition={Bounce}
      />
    </ConfigProvider>
  );
}

export default App;
